// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__38_ow","colMaxWidth":"Table_colMaxWidth__1fLTX"};